import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { ReferralPage } from '@/features/referrals'
import { usePanelStore } from '@/components/conversation/panel-store'

export const Route = createFileRoute('/_layout/_app/referrals/$id')({
  component: ReferralsRoute,
  staticData: { title: 'Napotnice' },
})

function ReferralsRoute() {
  const { id } = Route.useParams()
  const closePanel = usePanelStore((s) => s.closePanel)

  useEffect(() => {
    closePanel(true)
  }, [id])

  useEffect(() => {
    return () => closePanel(true)
  }, [])

  return <ReferralPage id={id} />
}
